import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import RoutableTabsBreaking from "../../molecules/RoutableTabsBreaking";
import useResponsive from "../../util/useResponsive";
const PregnancyPageTabs = ({ addEntryButton, isDoctor = false }) => {
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    const filterForDoctor = ["pregnancy_body", "pregnancy_baby"];
    const tabs = [
        {
            title: t("bodyChanges"),
            route: "pregnancy_body",
            params: {},
        },
        {
            title: t("pregnancy:babyDevelopment"),
            route: "pregnancy_baby",
            params: {},
        },
        {
            title: t("measures:title"),
            route: "pregnancy_measurement",
            params: {},
        },
        {
            title: t("pregnancy:feelingAndSymptoms"),
            route: "pregnancy_feeling",
            params: {},
        },
    ];
    return (_jsx(Box, Object.assign({ testID: "tabs", px: {
            base: 2,
            md: 4,
        }, backgroundColor: "white", borderColor: "gray.100", borderBottomWidth: 1, borderLeftWidth: 1, borderRightWidth: 1 }, { children: _jsxs(Stack, Object.assign({ direction: isSmallScreen ? "column" : "row", space: 2, 
            //width="full"
            alignItems: "flex-start", justifyContent: addEntryButton ? "space-between" : "flex-start" }, { children: [_jsx(RoutableTabsBreaking, { tabs: !isDoctor
                        ? [...tabs]
                        : tabs.filter((tab) => !filterForDoctor.includes(tab.route)), _tab: {
                        px: 2,
                        py: {
                            base: 2,
                            sm: isSmallScreen && tabs.length > 2 ? 2 : 4,
                        },
                    } }), addEntryButton] })) })));
};
export default PregnancyPageTabs;
